import React from 'react';
import { logError } from '../utils/errorReporter';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    logError(error, 'ErrorBoundary', { componentStack: info?.componentStack });
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fafafa',
        padding: 24,
      }}>
        <div style={{
          maxWidth: 480,
          background: '#fff',
          border: '1px solid #eee',
          borderRadius: 12,
          padding: 32,
          textAlign: 'center',
          boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
          <h2 style={{ margin: '0 0 12px', fontSize: 20, color: '#222' }}>
            Что-то пошло не так
          </h2>
          <p style={{ margin: '0 0 24px', color: '#666', fontSize: 14, lineHeight: 1.5 }}>
            Произошла непредвиденная ошибка. Попробуйте обновить страницу.
            Если проблема повторится — сообщите нам.
          </p>
          {this.state.error?.message && (
            <pre style={{
              fontSize: 12,
              color: '#999',
              background: '#f5f5f5',
              padding: 12,
              borderRadius: 6,
              textAlign: 'left',
              overflow: 'auto',
              maxHeight: 120,
              marginBottom: 24,
            }}>
              {this.state.error.message}
            </pre>
          )}
          <button
            onClick={this.handleReload}
            style={{
              background: '#ee5a24',
              color: '#fff',
              border: 'none',
              padding: '10px 24px',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Обновить страницу
          </button>
        </div>
      </div>
    );
  }
}
